(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image-with-zoom"] && !Shopify.designMode) return;
  try {
    // Theme editor only: selecting a zoom image opens the modal it lives in,
  // otherwise the merchant would be editing a block hidden behind a closed modal.
  (function () {
    if (!window.Shopify || !window.Shopify.designMode) return;

    function getModal(target) {
      var wrapper = target.closest('.image-with-zoom');
      return wrapper ? wrapper.querySelector('modal-dialog.image-zoom-modal') : null;
    }

    document.addEventListener('shopify:block:select', function (event) {
      if (!event.target.closest('.zoom-image')) return;
      var modal = getModal(event.target);
      if (!modal || modal.hasAttribute('open')) return;
      var opener = event.target
        .closest('.image-with-zoom')
        .querySelector('.image-with-zoom__toggle');
      modal.show(opener);
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      if (!event.target.closest('.zoom-image')) return;
      var modal = getModal(event.target);
      if (modal && modal.hasAttribute('open')) modal.hide();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
